// extracted by mini-css-extract-plugin
export default {"container":"dropdownMenu_container__XV6u-","menu":"dropdownMenu_menu__phT+D","center":"dropdownMenu_center__eY9sW","item":"dropdownMenu_item__-sqLS"};